import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export const LegalPage = ({ title, updated, children, testId }) => (
  <div data-testid={testId} className="min-h-screen bg-night text-foreground">
    <header className="border-b border-white/10 bg-night/80 backdrop-blur-xl sticky top-0 z-40">
      <div className="max-w-4xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" data-testid="legal-brand" className="flex items-center">
          <span className="bg-white rounded-md px-3 py-1.5 flex items-center shadow-md shadow-black/30">
            <img src="/globus-lockup.png" alt="Globus Financial Services" className="h-7 w-auto object-contain" />
          </span>
        </Link>
        <Link data-testid="legal-back-link" to="/" className="text-sm text-[#A0AAB2] hover:text-gold transition-colors flex items-center gap-2">
          <ArrowLeft size={14} /> Back to site
        </Link>
      </div>
    </header>
    <main className="max-w-4xl mx-auto px-6 py-16">
      <p className="overline-label mb-4">Legal</p>
      <h1 className="font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tight mb-3">{title}</h1>
      <p className="text-xs text-muted-foreground mb-12">Last updated: {updated}</p>
      <div className="space-y-10 text-[#A0AAB2] leading-relaxed text-base">{children}</div>
    </main>
    <footer className="border-t border-white/10">
      <div className="max-w-4xl mx-auto px-6 py-6 text-xs text-muted-foreground">
        © {new Date().getFullYear()} Globus Financial Services · Sahibabad, Uttar Pradesh 201005, India · GSTIN: 09AEFPK4400F1ZW
      </div>
    </footer>
  </div>
);

export const LegalSection = ({ title, children }) => (
  <section>
    <h2 className="font-serif text-xl sm:text-2xl text-foreground mb-3">{title}</h2>
    <div className="space-y-3">{children}</div>
  </section>
);
